// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ar { direction: rtl; float: right}`, "",{"version":3,"sources":["webpack://./src/app/people/components/commonClasses/people-survey-request/send-methods/copypaste/copypaste.component.ts"],"names":[],"mappings":"AAAA,MAAM,cAAc,EAAE,YAAY","sourcesContent":[".ar { direction: rtl; float: right}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
